<template>
    <button :type="type" class="btn btn-success" :disabled="isDisabled" @click="onClick()">
        <span v-if="form.isSubmitted"><i class="fa fa-spin fa-spinner"></i> <span v-text="processingText"></span></span>
        <span v-else><i v-if="withIcon" class="fa" :class="icon"></i> <slot></slot></span>
    </button>
</template>
<script>
    export default {
        props: {
            form: {
                type: Object,
                required: true,
            },
            type:{
                type: String,
                required: false,
                default: 'button',
            },
            processingText: {
                type: String,
                required: false,
                default: 'Saving'
            },
            icon: {
                type: String,
                required: false,
                default: 'fa fa-plus-circle'
            },
            withIcon: {
                type: Boolean,
                required: false,
                default: true,
            },
            disabled:{
                type: Boolean,
                required: false,
                default: false,
            }
        },

        methods: {
            onClick() {
                this.$emit('click');
            }
        },

        computed:{
            isDisabled() {
                return this.form.isSubmitted || this.disabled;
            }
        }
    }
</script>